import React, { useEffect, useState } from "react";
import { Autocomplete, Box, Breadcrumbs, Card, CardContent, Collapse, FormControl, Grid, IconButton, InputAdornment, List, OutlinedInput, Paper, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from "@mui/material";
import Navbar from "../components/Navbar";

import {
  ConvertDate,
  GetErrorMessageFromResponse,
  GetTime,
  ITCatalogOrderXMLCompomnent,
  UTCToCurrentTimeZone,
} from "../common/commonFunction";
import { useConfirmPopup } from "../components/context/confirmation-context";
import { useSnackBar } from "../components/context/snackbar-context";
import Loader from "../components/common components/Loader";
import PendingRequestThreeDots from "../components/PendingRequestThreeDots";
import { NavLink, useSearchParams } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { userStore } from "../store/store";
import ShowNotes from "../components/ShowNotes";
import { UserRequestListService } from "./../services/UserRequestListService";
import PendingRequestItemsKenbanMenu from "./../components/PendingRequestItemsKenbanMenu";
import InfoIcon from "@mui/icons-material/Info";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CloseIcon from "@mui/icons-material/Close";
import ShowItemFormData from "../components/modelPopup/ShowItemFormData";
import ApprovedIcon from "../assets/icon/Approved.png";
import DeniedIcon from "../assets/icon/Denied.png";
import NoteIcon from "../assets/icon/notes.png";
import { addBehalfUserToSysAidPayload, processRequestItems } from "../common/utils";
import dayjs from "dayjs";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";


const PendingRequests = () => {
  const [isLoading, setIsloading] = useState(true);
  const [selectedRequestNotes, SetSelectedRequestNotes] = useState<any>([]);
  const [selectedItemFormDetails, SetSelectedItemFormDetails] = useState<any>(
    []
  );
  const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>({});
  const handleExpandClick = (requestId: string) => {
    setExpandedRows((prev) => ({ ...prev, [requestId]: !prev[requestId] }));
  };
  const [selectedItemDetails, SetselectedItemDetails] = useState<any>();
  const [selectedRequestId, SetselectedRequestId] = useState<any>();
  const [OpenShowNotePopup, SetOpenShowNotePopup] = useState(false);
  const [OpenShowItemDetailsPopup, SetOpenShowItemDetailsPopup] =
    useState(false);
  const [pendingRequests, setPendingRequests] = React.useState<any>([]);
  const snackbar = useSnackBar();
  const confirmPopupService = useConfirmPopup();
  const uStore: any = userStore();
  const [filteredPendingRequests, setFilteredPendingRequests] = useState<any>([]);
  const [uniqueCreatedBy, setUniqueCreatedBy] = useState<any>([]);
  const [uniqueBehalfUserName, setUniqueBehalfUserName] = useState<any>([]);
  const [createdByFilters, setCreatedByFilters] = useState<any>([]);
  const [behalfUserNameFilters, setBehalfUserNameFilters] = useState<any>([]);
  const [uniqueItemType, setUniqueItemType] = useState<any>([]);
  const [itemTypeFilters, setItemTypeFilters] = useState<any>([]);
  const [dateRange, setDateRange] = useState<{ start: dayjs.Dayjs | null, end: dayjs.Dayjs | null }>({ start: null, end: null });
  

  const createdByHandler = (event: any, selectedCreatedBy: string[]) => {
    setIsloading(true);
    setCreatedByFilters(selectedCreatedBy);
  };

  const behalfUserNameHandler = (event: any, selectedBehalfUserName: string[]) => {
    setIsloading(true);
    setBehalfUserNameFilters(selectedBehalfUserName);
  };

  const itemTypeHandler = (event: any, selectedItemType: string[]) => {
    setIsloading(true);
    setItemTypeFilters(selectedItemType);
  };

  const getPendingRequest = async () => {
    let res = await UserRequestListService.GetAllPendingRequestList(
      uStore.getUser().userEmail
    );
    if (res.data) {
      setPendingRequests(res.data.data);
      setFilteredPendingRequests(res.data.data);
      const uniqueCreatedByValues = [];
      const seen = new Set();
      for (const item of res.data.data) {
        if (!seen.has(item.createdUserName)) {
          uniqueCreatedByValues.push(item.createdUserName);
          seen.add(item.createdUserName);
        }
      }
      setUniqueCreatedBy(uniqueCreatedByValues.sort());

      const uniqueBehalfUserNameValues: any[] = [];
      const seenUsers = new Set();
      for (const item of res.data.data) {
        if (item.behalfUserName != null && item.behalfUserName != "") {
          if (!seenUsers.has(item.behalfUserName)) {
            uniqueBehalfUserNameValues.push(item.behalfUserName);
            seenUsers.add(item.behalfUserName);
          }
        }
      }
      setUniqueBehalfUserName(uniqueBehalfUserNameValues.sort());

      const uniqueItemTypeValues: any[] = [];
      const seenItemType = new Set();
      for (const item of res.data.data) {
        for (const request of item.items) {
          if (request.description != null && request.description != "") {
            if (!seenItemType.has(request.description)) {
              uniqueItemTypeValues.push(request.description);
              seenItemType.add(request.description);
            }
          }
        }
      }
      setUniqueItemType(uniqueItemTypeValues.sort());

      setIsloading(false);
    }
  };

  const handleCancelRequest = async (id: any) => {
    confirmPopupService.showPopup(
      "Are you sure you want to cancel this request? You will not be able to recover it once it is cancelled.",
      () => {
        handleCanceledRequest(id);
      }
    );
  };

  const handleCanceledRequest = async (id: any) => {
    let res = await UserRequestListService.CancelRequestList(id);
    if (res.data) {
      if (res.data.code === 200 && res.data.data === "success") {
        snackbar.showSnackBar(
          "Your request has been canceled successfully.",
          "success"
        );
        getPendingRequest();
      } else {
        snackbar.showSnackBar("Your request has not been cancele", "error");
      }
    } else {
      snackbar.showSnackBar("Internal server error.", "error");
    }
    confirmPopupService.hidePopup();
  };

  const handleCancelItemOfRequest = async (requestId: any, itemId: any) => {
    confirmPopupService.showPopup(
      "Are you sure you want to cancel this item from request? You will not be able to recover it once it is cancelled.",
      () => {
        handleCanceledItemOfRequest(requestId, itemId);
      }
    );
  };

  const handleCanceledItemOfRequest = async (requestId: any, itemId: any) => {
    let res = await UserRequestListService.CancelItemOfRequest(
      requestId,
      itemId
    );
    if (res.data) {
      if (res.data.code === 200 && res.data.data === "success") {
        snackbar.showSnackBar(
          "Your item has been removed from request successfully.",
          "success"
        );
        getPendingRequest();
      } else {
        snackbar.showSnackBar(
          "Your item has not been removed from request.",
          "error"
        );
      }
    } else {
      snackbar.showSnackBar("Internal server error.", "error");
    }
    confirmPopupService.hidePopup();
  };

  const addNotes = (
    requestId: any,
    noteText: string,
    handleCloseDialog: () => void
  ) => {
    const userName = uStore.getUser().userEmail;
    UserRequestListService.AddNoteForRequest(requestId, noteText, userName)
      .then((res: any) => {
        if (res) {
          handleCloseDialog();
          if (res.data.code === 200 && res.data.data === "success") {
            getPendingRequest();
            snackbar.showSnackBar(
              "Note has been added successfully.",
              "success"
            );
          } else if (res.data.code === 404) {
            snackbar.showSnackBar(res.data.data, "error");
          } else {
            snackbar.showSnackBar("Note has not been added.", "error");
          }
        }
      })
      .catch((err) => {
        handleCloseDialog();
        snackbar.showSnackBar(GetErrorMessageFromResponse(err), "error");
      });
  };

  const handleapproveRequest = async (
    requestWithItem: any,
    newStatus: any,
    createdUserEmail: string,
    CreatedUserName: string
  ) => {
    confirmPopupService.showPopup(
      "Are you sure you want to approve all items on this request?",
      () => {
        approveRequest(
          requestWithItem,
          newStatus,
          createdUserEmail,
          CreatedUserName
        );
      }
    );
  };

  const approveRequest = (
    requestWithItem: any,
    newStatus: string,
    createdUserEmail: string,
    createdUserName: string
  ) => {
    const {
      processedItems,
      ItemsWithGeneralHardwareRequest,
      ItemsWithoutGeneralHardwareRequest,
    } = processRequestItems(
      requestWithItem?.items,
      createdUserEmail,
      createdUserName,
      requestWithItem?.behalfUserName
    );

    const cXMlRequestPayload = ITCatalogOrderXMLCompomnent(
      processedItems,
      `${uStore.getUser().firstName} ${uStore.getUser().lastName}`,
      uStore.getUser().userEmail
    );

    UserRequestListService.ChangeCurrentRequestStatus(
      requestWithItem,
      newStatus,
      uStore.getUser().userEmail,
      null,
      cXMlRequestPayload,
      ItemsWithGeneralHardwareRequest,
      ItemsWithoutGeneralHardwareRequest
    )
      .then((res: any) => {
        if (res) {
          if (res.data.code === 200) {
            getPendingRequest();
            snackbar.showSnackBar(res.data.data, "success");
          } else {
            snackbar.showSnackBar(
              res.data.data || "All items of request have not been approved.",
              "error"
            );
          }
          confirmPopupService.hidePopup();
        }
      })
      .catch((err) => {
        confirmPopupService.hidePopup();
        snackbar.showSnackBar(GetErrorMessageFromResponse(err), "error");
      });
  };

  const handleapproveItemOfRequest = async (
    requestId: any,
    item: any,
    newStatus: any,
    createdUserEmail: string,
    CreatedUserName: string,
    behalfUserName?: string
  ) => {
    confirmPopupService.showPopup(
      "Are you sure you want to approve this item?",
      () => {
        approveItemOfRequest(
          requestId,
          item,
          newStatus,
          createdUserEmail,
          CreatedUserName,
          behalfUserName
        );
      }
    );
  };
  const approveItemOfRequest = (
    requestId: any, // need to add behalfOfUserName here but maybe in the backend to avoid all these crossed wires.
    item: any,
    newStatus: string,
    createdUserEmail: string,
    CreatedUserName: string,
    behalfUserName?: string
  ) => {
    let items = [];
    items.push(item);

    let problemTypeValue = "";
    let descriptionValue = item.description;
    if (item.category.id === 1) {
      problemTypeValue = "Hardware Request";
    } else if (item.category.id === 2) {
      problemTypeValue = "Software Request_New Software";
      if (item.formData) {
          try {
            const formDataObj = JSON.parse(item.formData);
            if (formDataObj && formDataObj["Details"]) {
              descriptionValue = formDataObj["Details"]  + "\n" + CreatedUserName;
            }
          } catch {}
        }
    } else if (item.category.id === 4) {
      problemTypeValue = "Employee Lifecycle";
    }

    const numWeeks = 2;
    const now = new Date();
    now.setDate(now.getDate() + numWeeks * 7);

    const SysAidpayload: any = {
      info: [
        { key: "due_date", value: now.getTime().toString() },
        { key: "status", value: "2" },
        { key: "problem_type", value: problemTypeValue },
        { key: "description", value: descriptionValue },
        { key: "CustomColumn93sr", value: CreatedUserName },
        { key: "request_user_name", value: CreatedUserName },
        {
          key: "notes",
          value: [],
        },
      ],
    };

    if (item.category.id === 2) {
        SysAidpayload.info.push({ key: "title", value: item.description });
      }

    if (item.formData) {
      let formDataValue = JSON.parse(item.formData);
      var formDataValueResultArrayObject: any = Object.keys(formDataValue).map(
        function (key) {
          return { key: key, value: formDataValue[key] };
        }
      );
      if (item.sysAidTemplateId) {
        formDataValueResultArrayObject.map((obj: any) => {
          SysAidpayload.info.push(obj);
        });
      }
    }

    addBehalfUserToSysAidPayload(SysAidpayload, behalfUserName);

    const cXMlRequestPayload = ITCatalogOrderXMLCompomnent(
      items,
      uStore.getUser().firstName + " " + uStore.getUser().lastName,
      uStore.getUser().userEmail
    );
    UserRequestListService.ChangeCurrentRequestItemStatus(
      requestId,
      item.requestItemID,
      item,
      newStatus,
      uStore.getUser().userEmail,
      null,
      cXMlRequestPayload,
      JSON.stringify(SysAidpayload)
    )
      .then((res: any) => {
        if (res) {
          if (res.data.code === 200 && res.data.data === "success") {
            getPendingRequest();
            snackbar.showSnackBar(
              "Request item has been approved successfully.",
              "success"
            );
          } else if (res.data.code === 404) {
            snackbar.showSnackBar(res.data.data, "error");
          } else if (res.data.code === 400) {
            snackbar.showSnackBar(res.data.data, "error");
          } else {
            snackbar.showSnackBar(
              "Request item has not been approved successfully.",
              "error"
            );
          }
          confirmPopupService.hidePopup();
        }
      })
      .catch((err) => {
        snackbar.showSnackBar(GetErrorMessageFromResponse(err), "error");
        confirmPopupService.hidePopup();
      });
  };

  const deniedRequest = (
    requestWithItem: any,
    newStatus: string,
    deniedReason: string,
    handleCloseDialog: () => void
  ) => {
    UserRequestListService.ChangeCurrentRequestStatus(
      requestWithItem,
      newStatus,
      uStore.getUser().userEmail,
      deniedReason
    )
      .then((res: any) => {
        if (res) {
          handleCloseDialog();
          if (res.data.code === 200 && res.data.data === "success") {
            getPendingRequest();
            snackbar.showSnackBar(
              "All items of request has been denied successfully.",
              "success"
            );
          } else if (res.data.code === 404) {
            snackbar.showSnackBar(res.data.data, "error");
          } else if (res.data.code === 400) {
            snackbar.showSnackBar(res.data.data, "error");
          } else {
            snackbar.showSnackBar(
              "All items of request has not been denied.",
              "error"
            );
          }
        }
      })
      .catch((err) => {
        handleCloseDialog();
        snackbar.showSnackBar(GetErrorMessageFromResponse(err), "error");
      });
  };

  const deniedItemOfRequest = (
    requestId: any,
    item: any,
    newStatus: string,
    deniedReason: string,
    handleCloseDialog: () => void
  ) => {
    UserRequestListService.ChangeCurrentRequestItemStatus(
      requestId,
      item.requestItemID,
      item,
      newStatus,
      uStore.getUser().userEmail,
      deniedReason
    )
      .then((res: any) => {
        if (res) {
          handleCloseDialog();
          if (res.data.code === 200 && res.data.data === "success") {
            getPendingRequest();
            snackbar.showSnackBar(
              "Request item has been denied successfully.",
              "success"
            );
          } else if (res.data.code === 404) {
            snackbar.showSnackBar(res.data.data, "error");
          } else if (res.data.code === 400) {
            snackbar.showSnackBar(res.data.data, "error");
          } else {
            snackbar.showSnackBar(
              "Request has not been denied successfully.",
              "error"
            );
          }
        }
      })
      .catch((err) => {
        handleCloseDialog();
        snackbar.showSnackBar(GetErrorMessageFromResponse(err), "error");
      });
  };
  const handleCloseShowNotePopup = (isShowPopup: boolean) => {
    SetOpenShowNotePopup(isShowPopup);
  };

  const handleCloseShowItemDetialsPopup = (isShowPopup: boolean) => {
    SetOpenShowItemDetailsPopup(isShowPopup);
  };

  const changeStartDateForNewEmployee = (
    date: any,
    formDetailsWithTitle: any,
    formData: any,
    selectedItemId: any,
    selectedRequestId: any
  ) => {
    const newFormDetailsWithTitle = JSON.parse(formDetailsWithTitle);
    const updatedformDetailsWithTitle: any = { ...newFormDetailsWithTitle };

    updatedformDetailsWithTitle["Start Date"] = date;

    const newFormData = JSON.parse(formData);
    const updateFormData: any = { ...newFormData };
    updateFormData["CustomColumn64sr"] = new Date(date).getTime().toString();

    UserRequestListService.UpdateStartDateIntoItemFormDetails(
      selectedRequestId,
      selectedItemId,
      updatedformDetailsWithTitle,
      updateFormData
    )
      .then((res: any) => {
        if (res) {
          if (res && res.data.code === 200) {
            handleCloseShowItemDetialsPopup(false);
            snackbar.showSnackBar(res.data.data, "success");
            getPendingRequest();
          } else {
            handleCloseShowItemDetialsPopup(false);
            snackbar.showSnackBar(res.data.data, "error");
          }
        }
      })
      .catch((err) => {
        snackbar.showSnackBar(GetErrorMessageFromResponse(err), "error");
      });
  };

  const filterRequests = () => {
    let filteredRequests = pendingRequests;
    const filters: ((request: any) => boolean)[] = [];
  
    if (createdByFilters && createdByFilters.length > 0) {
      filters.push((request) => createdByFilters.includes(request.createdUserName));
    }
  
    if (behalfUserNameFilters && behalfUserNameFilters.length > 0) {
      filters.push((request) => behalfUserNameFilters.includes(request.behalfUserName));
    }
  
    if (itemTypeFilters && itemTypeFilters.length > 0) {
      filters.push((request) => {
        return request.items.some((item: any) => {
          return itemTypeFilters.includes(item.description);
        })
      })
    }

    if (dateRange.start || dateRange.end) {
      let start: Date | null = null;
      let end: Date | null = null;
      if (dateRange.start) start = dateRange.start.startOf('day').toDate();
      if (dateRange.end) end = dateRange.end.endOf('day').toDate();
      
      filters.push((request) => {
          const reqDate = new Date(ConvertDate(request.createdDate));
          if (start && end) {
              return reqDate >= start && reqDate <= end;
          } else if (start) {
              return reqDate >= start;
          } else if (end) {
              return reqDate <= end;
          }
          return false;
      });
    }
  
    filteredRequests = filters.reduce(
      (acc, filter) => acc.filter(filter),
      pendingRequests
    );
    setFilteredPendingRequests(filteredRequests);
  };

  useEffect(() => {
    if (!pendingRequests || pendingRequests.length === 0) {
      getPendingRequest();
    }
    else {
      filterRequests();
      setIsloading(false);
    }
  }, [createdByFilters, behalfUserNameFilters, itemTypeFilters, dateRange])
  
  return (
    <>
      <div className="breadcumDiv">
        {uStore.getUser().role === "Administrator" ? (
          <Breadcrumbs
            separator={<ArrowForwardIosIcon />}
            aria-label="breadcrumb"
          >
            <span className="active-breadcumb">Pending Request</span>
          </Breadcrumbs>
        ) : (
          <Breadcrumbs
            separator={<ArrowForwardIosIcon />}
            aria-label="breadcrumb"
          >
            <NavLink to="/search" title="Make A Request">
              Make A Request
            </NavLink>
            <span className="active-breadcumb">Pending Request</span>
          </Breadcrumbs>
        )}
      </div>
      <Navbar title="Pending Request" />
      <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: '10px',
      padding: '20px',
      backgroundColor: '#f0f0f0',
      }}>
          <Autocomplete
            multiple={true}
            options={ uniqueCreatedBy }
            getOptionLabel={(option: string) => option}
            renderInput={(params) => <TextField {...params} label="Requested By" />}
            sx={{
              flex: 1,
              minWidth: '200px',
              fontSize: '1rem',
            }}
            onChange={createdByHandler}
            ></Autocomplete>
          <Autocomplete
            multiple={true}
            options={ uniqueBehalfUserName }
            getOptionLabel={(option: string) => option}
            renderInput={(params) => <TextField {...params} label="On Behalf Of" />}
            sx={{
              flex: 1,
              minWidth: '200px',
              fontSize: '1rem', 
            }}
            onChange={behalfUserNameHandler}
          ></Autocomplete>
          <Autocomplete
            multiple={true}
            options={ uniqueItemType }
            getOptionLabel={(option: string) => option}
            renderInput={(params) => <TextField {...params} label="Item Type" />}
            sx={{
              flex: 1,
              minWidth: '200px',
              fontSize: '1rem', 
            }}
            onChange={itemTypeHandler}
          ></Autocomplete>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <DatePicker
                      label="Start Date"
                      value={dateRange.start}
                      onChange={(newValue) => {
                          setDateRange((prev) => ({ ...prev, start: newValue ?? null }));
                      }}
                      slotProps={{ textField: { sx: { minWidth: '150px', fontSize: '1rem', m: 0 } } }}
                  />
                  <IconButton
                      aria-label="Clear start date"
                      onClick={() => setDateRange((prev) => ({ ...prev, start: null }))}
                      disabled={!dateRange.start}
                      size="small"
                      sx={{ color: 'red', p: 0.5 }}
                  >
                      <CloseIcon fontSize="small" />
                  </IconButton>
                  <DatePicker
                      label="End Date"
                      value={dateRange.end}
                      onChange={(newValue) => {
                          setDateRange((prev) => ({ ...prev, end: newValue ?? null }));
                      }}
                      slotProps={{ textField: { sx: { minWidth: '150px', fontSize: '1rem', m: 0 } } }}
                  />
                  <IconButton
                      aria-label="Clear end date"
                      onClick={() => setDateRange((prev) => ({ ...prev, end: null }))}
                      disabled={!dateRange.end}
                      size="small"
                      sx={{ color: 'red', p: 0.5 }}
                  >
                      <CloseIcon fontSize="small" />
                  </IconButton>
              </Box>
          </LocalizationProvider>
        </div>
          
      <Card
        sx={{
          mt: 3,
          p: 2,
          width: "100%",
          textAlign: "start",
          boxShadow: "none",
        }}
      >
        <CardContent>
          {isLoading ? (
            <Loader />
          ) : (
            <div style={{ width: '100%', overflowX: 'auto' }}>
              {filteredPendingRequests && filteredPendingRequests.length > 0 ? (
                <TableContainer component={Paper}>
                  <Table style={{ minWidth: 650 }} aria-label="pending requests table">
                    <TableHead>
                      <TableRow style={{ background: '#f5f5f5' }}>
                        <TableCell>Request ID</TableCell>
                        <TableCell>Requested By</TableCell>
                        <TableCell>Requested Date</TableCell>
                        <TableCell>Item Categories</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>On Behalf Of</TableCell>
                        <TableCell>Notes</TableCell>
                        <TableCell>Actions</TableCell>
                        <TableCell />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredPendingRequests.map((list: any) => {
                        const hasBehalf = !!list.behalfUserName;
                        const hasNotes = list.request_Notes && list.request_Notes.length > 0;
                        return (
                          <React.Fragment key={list.id}>
                            <TableRow hover style={{ background: '#fff' }}>
                              <TableCell>{list.id}</TableCell>
                              <TableCell>{list.createdUserName}</TableCell>
                              <TableCell>{ConvertDate(list.createdDate)} @ {GetTime(list.createdDate)}</TableCell>
                              <TableCell>{Array.from(new Set(list.items.map((item: any) => item.itemSubCategory))).join(', ')}</TableCell>
                              <TableCell>
                                {list.status === 'Pending' && <span><b>Status:</b> Pending</span>}
                                {list.status === 'Approved' && (
                                  <span style={{ color: 'green', fontWeight: 600 }}>
                                    <img className='ApprovedDeniedIcon' src={ApprovedIcon} alt='' style={{ height: 20, width: 20, verticalAlign: 'middle' }} /> Approved
                                  </span>
                                )}
                                {list.status === 'Denied' && (
                                  <span style={{ color: 'red', fontWeight: 600 }}>
                                    <img className='ApprovedDeniedIcon' src={DeniedIcon} alt='' style={{ height: 20, width: 20, verticalAlign: 'middle' }} /> Denied
                                  </span>
                                )}
                              </TableCell>
                              <TableCell>{hasBehalf ? list.behalfUserName : ''}</TableCell>
                              <TableCell>
                                {hasNotes ? (
                                  <Tooltip
                                    title={<span style={{ whiteSpace: 'pre-line', fontSize: '1.25rem', padding: 8, display: 'block', lineHeight: 1.5 }}>{list.request_Notes.map((n: any) => n.note || n).join('\n')}</span>}
                                    placement="top"
                                    arrow
                                    PopperProps={{
                                      modifiers: [
                                        {
                                          name: 'offset',
                                          options: {
                                            offset: [0, 8],
                                          },
                                        },
                                      ],
                                      sx: { '& .MuiTooltip-tooltip': { maxWidth: 400, padding: 2 } }
                                    }}
                                  >
                                    <span>
                                      <InfoIcon style={{ color: '#1976d2', verticalAlign: 'middle', cursor: 'default' }} />
                                    </span>
                                  </Tooltip>
                                ) : ''}
                              </TableCell>
                              <TableCell>
                                {uStore.getUser().role !== 'HR' && (
                                  <PendingRequestThreeDots
                                    list={list}
                                    deniedRequest={(requestWithItem, newStatus, deniedReason, handleCloseDialog) => {
                                      deniedRequest(requestWithItem, newStatus, deniedReason, handleCloseDialog);
                                    }}
                                    approveRequest={(requestWithItem, newStatus, createdUserEmail, CreatedUserName) => {
                                      handleapproveRequest(requestWithItem, newStatus, createdUserEmail, CreatedUserName);
                                    }}
                                    addNotes={(id, noteText, handleCloseDialog) => {
                                      addNotes(id, noteText, handleCloseDialog);
                                    }}
                                    handleCancelRequest={(id) => handleCancelRequest(id)}
                                  />
                                )}
                              </TableCell>
                              <TableCell>
                                <IconButton
                                  aria-label="expand row"
                                  size="small"
                                  onClick={() => handleExpandClick(list.id)}
                                >
                                  {expandedRows && expandedRows[list.id] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </IconButton>
                              </TableCell>
                            </TableRow>
                            <TableRow>
                              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={8}>
                                <Collapse in={expandedRows && expandedRows[list.id]} timeout="auto" unmountOnExit>
                                  <Box margin={2}>
                                    <Table size="small" aria-label="items">
                                      <TableHead>
                                        <TableRow>
                                          <TableCell>Item ID</TableCell>
                                          <TableCell>Item Description</TableCell>
                                          {list.items.some((item: any) => item.itemSubCategory === "Employee Life Cycle") ? (
                                              <TableCell>Employee Name</TableCell>
                                          ) : null}
                                          <TableCell>Status</TableCell>
                                          <TableCell>Denied Reason</TableCell>
                                          <TableCell>Details</TableCell>
                                          <TableCell>Actions</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {list.items.map((item: any) => {
                                          const hasDeniedReason = item.status === 'Denied' && item.deniedReason;
                                          return (
                                            <TableRow key={item.requestItemID}>
                                              <TableCell>{item.requestItemID}</TableCell>
                                              <TableCell>{item.description}</TableCell>
                                              {list.items.some((itm: any) => itm.itemSubCategory === "Employee Life Cycle") ? (
                                                  <TableCell>
                                                      {item.itemSubCategory === "Employee Life Cycle" ? (() => {
                                                          let details: any = {};
                                                          try {
                                                              details = JSON.parse(item.formDataWithTitle);
                                                          } catch {}
                                                          if (typeof details === 'object' && details !== null) {
                                                              if (details["Employee Name"]) {
                                                                  return details["Employee Name"];
                                                              }
                                                          }
                                                          return "N/A";
                                                      })() : ""}
                                                  </TableCell>
                                              ) : null}
                                              <TableCell>
                                                {item.status === 'Pending' && <span><b>Status:</b> Pending</span>}
                                                {item.status === 'Approved' && (
                                                  <span style={{ color: 'green', fontWeight: 600 }}>
                                                    <img className='ApprovedDeniedIcon' src={ApprovedIcon} alt='' style={{ height: 20, width: 20, verticalAlign: 'middle' }} /> Approved
                                                  </span>
                                                )}
                                                {item.status === 'Denied' && (
                                                  <span style={{ color: 'red', fontWeight: 600 }}>
                                                    <img className='ApprovedDeniedIcon' src={DeniedIcon} alt='' style={{ height: 20, width: 20, verticalAlign: 'middle' }} /> Denied
                                                  </span>
                                                )}
                                              </TableCell>
                                              <TableCell>
                                                {hasDeniedReason ? (
                                                  <Tooltip
                                                    title={<span style={{ whiteSpace: 'pre-line', fontSize: '1.1rem', padding: 8, display: 'block', lineHeight: 1.5 }}>{item.deniedReason}</span>}
                                                    placement="top"
                                                    arrow
                                                    PopperProps={{
                                                      modifiers: [
                                                        {
                                                          name: 'offset',
                                                          options: {
                                                            offset: [0, 8],
                                                          },
                                                        },
                                                      ],
                                                      sx: { '& .MuiTooltip-tooltip': { maxWidth: 400, padding: 2 } }
                                                    }}
                                                  >
                                                    <span>
                                                      <InfoIcon style={{ color: '#1976d2', verticalAlign: 'middle', cursor: 'default' }} />
                                                    </span>
                                                  </Tooltip>
                                                ) : ''}
                                              </TableCell>
                                              <TableCell>
                                                {item.formDataWithTitle && (
                                                  <InfoIcon
                                                    onClick={() => {
                                                      SetOpenShowItemDetailsPopup(true);
                                                      SetSelectedItemFormDetails(item.formDataWithTitle);
                                                      SetselectedItemDetails(item);
                                                      SetselectedRequestId(list.id);
                                                    }}
                                                    style={{ height: '30px', width: '24px', cursor: 'pointer', verticalAlign: 'middle' }}
                                                  />
                                                )}
                                              </TableCell>
                                              <TableCell>
                                                {uStore.getUser().role !== 'HR' && (
                                                  <PendingRequestItemsKenbanMenu
                                                    list={list}
                                                    item={item}
                                                    deniedItemOfRequest={(requestId, item, newStatus, deniedReason, handleDeniedItemReasonCloseDialog) => {
                                                      deniedItemOfRequest(requestId, item, newStatus, deniedReason, handleDeniedItemReasonCloseDialog);
                                                    }}
                                                    approveItemOfRequest={(requestId, item, newStatus, createdUserEmail, CreatedUserName) => {
                                                      handleapproveItemOfRequest(requestId, item, newStatus, createdUserEmail, CreatedUserName, list.behalfUserName);
                                                    }}
                                                    handleCancelItemOfRequest={(requestId, itemId) => handleCancelItemOfRequest(requestId, itemId)}
                                                  />
                                                )}
                                              </TableCell>
                                            </TableRow>
                                          );
                                        })}
                                      </TableBody>
                                    </Table>
                                  </Box>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <label className='noDataFoundMessage'> No Pending Request Found</label>
              )}
            </div>
          )}
        </CardContent>
      </Card>
      <ShowNotes
        requestNotes={selectedRequestNotes}
        isOpenDialog={OpenShowNotePopup}
        handleCloseShowNotePopup={(isShowPopup: any) => {
          handleCloseShowNotePopup(isShowPopup);
        }}
      />
      <ShowItemFormData
        selectedRequestId={selectedRequestId}
        selectedItemDetails={selectedItemDetails}
        changeStartDate={(
          date: any,
          formDetailsWithTitle: any,
          formData: any,
          selectedItemId: any,
          selectedRequestId: any
        ) =>
          changeStartDateForNewEmployee(
            date,
            formDetailsWithTitle,
            formData,
            selectedItemId,
            selectedRequestId
          )
        }
        formDetails={selectedItemFormDetails}
        isOpenDialog={OpenShowItemDetailsPopup}
        handleCloseShowItemDetialsPopup={(isShowPopup: any) => {
          handleCloseShowItemDetialsPopup(isShowPopup);
        }}
      />
    </>
  );
};

export default PendingRequests;
